export default __webpack_public_path__ + "static/new7-08-d5ecf25475e7dd9c019175e6720032e8.jpg";